<template>
  <div>
    <div class="m-5 px-5" >
    <div class="mx-auto">
    <table class="table table-hover m-3">
        <thead>
            <tr>
              <th>Condition #</th>
              <th>Num</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(value, name, index) in conditionCounter" :key="index">
                <th>{{ name }}</th>
                <th>{{ value }}</th>
            </tr>
            <tr>
                <th></th>
                <th>Total: {{this.numOfUsers.numOfActive}}</th>
            </tr>
        </tbody>
    </table>
    </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      numOfUsers: 0,
      conditionCounter: {},
      conditionList: [],
    };
  },
  methods: {
    getData() {
      const path = `${this.$hostname}/get-condition-counter`;
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.Auth);
          if (res.data.Auth !== 'admin') {
            this.$router.push({ name: 'Login' });
          } else {
            this.numOfUsers = res.data.numOfUsers;
            this.conditionCounter = res.data.conditionCounter;
            console.log(this.conditionList);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
